import { useEffect, useState } from 'react';
import ModalFoodItemNutrition from '../../modal/views/ModalFoodItemNutrition';

const FoodItemModal = ({ foodItem }) => {
    const [isOpen, setIsOpen] = useState(false);

    // OPEN VIA ICON BUTTON (FROM BLADE)
    useEffect(() => {
        const handler = (e) => {
            const trigger = e.target.closest(`[data-open-fooditem-modal="${foodItem.food_item_id}"]`);
            if (trigger) setIsOpen(true);
        };

        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, [foodItem.food_item_id]);

    // BODY SCROLL LOCK
    useEffect(() => {
        document.body.classList.toggle('modal-open', isOpen);

        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    return (
        <>
            {foodItem?.name && (
                <span className="meal-title" onClick={() => setIsOpen(true)}>
                    {foodItem.name}
                </span>
            )}

            {isOpen && (
                <>
                    <div className="modal" style={{ display: 'block' }} role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <ModalFoodItemNutrition
                                    payload={foodItem}
                                    onRequestClose={() => setIsOpen(false)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade in" onClick={() => setIsOpen(false)} />
                </>
            )}
        </>
    );
};

export default FoodItemModal;
